import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Partner } from 'types';
import { formatCurrencyDecimals, formatNumberDecimals } from 'utils/formats';

import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { useGetDividendDataForPartner } from '../../hooks/useGetDividendDataForPartner';

type DividendsOperationDataRowProps = {
  index: number;
  partner: Partner;
};

const DividendsOperationTableRow: FC<DividendsOperationDataRowProps> = ({
  index,
  partner,
}) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );
  const { data } = useOperationDetailsPage();

  const { _id: partnerId, name: partnerName } = partner;

  const { data: dividendsData } = useGetDividendDataForPartner({
    dividendOperation: data.operation,
    partner,
  });

  const cells = [
    {
      key: `partner-name-${index}`,
      content: (
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
        >
          {partnerName}
        </Link>
      ),
    },

    {
      key: `ndPercentage-${index}`,
      content: <span>{formatNumberDecimals(dividendsData.ndPercentage)}%</span>,
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: `retentionPercentage-${index}`,
      content: (
        <span>{formatNumberDecimals(dividendsData.retentionPercentage)}%</span>
      ),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: `amount-${index}`,
      content: <span>{formatCurrencyDecimals(dividendsData.amount)}</span>,
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: `amount-percibe-${index}`,
      content: formatCurrencyDecimals(
        dividendsData.amount - dividendsData.retentionAmount
      ),
      textPosition: 'right',
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};
export default DividendsOperationTableRow;
